import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IPermissionPreview } from "../models/auto-generated";

@Injectable({
  providedIn: "root"
})
export class PermissionMappingService {
  private getBaseRoute(instanceId: string, connectionId: string | number): string {
    return `/api/configurations/${instanceId}/sharepoint/${connectionId}/permission-mapping`;
  }
  constructor(private http: HttpClient) {}

  get(instanceId: string, connectionId: string | number): Observable<IPermissionPreview> {
    const baseRoute = this.getBaseRoute(instanceId, connectionId);
    return this.http.get<IPermissionPreview>(baseRoute);
  }
}
